import React from 'react';
import { motion } from 'framer-motion';
export function TopBanner() {
  const items = ['🔒 Pago 100% seguro MercadoPago', '📩 Acceso inmediato por mail', '💳 3 cuotas sin interés', '🎁 50% OFF por tiempo limitado'];
  const duplicated = [...items, ...items, ...items, ...items];
  return <div className="w-full bg-[#3E2B1F] overflow-hidden py-3" data-id="element-250">
      <motion.div className="flex whitespace-nowrap gap-12" animate={{
      x: ['0%', '-50%']
    }} transition={{
      x: {
        repeat: Infinity,
        repeatType: 'loop',
        duration: 15,
        ease: 'linear'
      }
    }} data-id="element-251">
        {duplicated.map((item, index) => <span key={index} className="text-[#F7F2EA] font-medium text-sm md:text-base flex-shrink-0 px-4 tracking-wide" data-id="element-252">
            {item}
          </span>)}
      </motion.div>
    </div>;
}